export default __webpack_public_path__ + "static/media/qr-scan.f9db65f0.svg";